export default __webpack_public_path__ + "static/media/enragingstrike3.5dc01531.png";